import React, { useEffect, useRef, useState } from "react";

//ASSETS

import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import RedLoop from "assets/svg/SearchIconRed.svg";

// STYLES
import {
  OfficialAnnouncementsContainer,
  BackToWrapper,
  BackToImage,
  BackToButton,
  InputContainer,
  ImgStyled,
  Wrapper,
  CardContainer,
  TitleWrapper,
  HeaderWrapper,
} from "./EventsStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// MISC

import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { appRoutes } from "config/AppRoutesConfig";
import { OptionType } from "components/Atoms/InputAtom/InputAtomModel";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { Filters } from "components/HeaderTab/HeaderTabModel";

// COMPONENTS

import InputAtom from "components/Atoms/InputAtom/InputAtom";
import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import EventCard from "components/EventCard/EventCard";
import Pagination from "components/Atoms/Paginations/Pagination";
import HeaderTab from "components/HeaderTab/HeaderTab";

// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// HOOKS
import usePagination from "hooks/usePagination";
import newsAndMediaService from "services/newsAndMediaService";
import { CheckProps } from "components/Atoms/SelectInputFilter/SelectInputFilterModel";

// CONFIGURATION

const Events = () => {
  // PROPERTIES

  // API REQUESTS

  // The tabs for the menu

  // Function to handle tab selection

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS

  const [inputText, setInputText] = useState<string>("");
  const [options, setOptions] = useState<OptionType[]>([]);
  //eslint-disable-next-line
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  //eslint-disable-next-line
  const [totalPages, setTotalPages] = useState<number>(10);
  const [events, setEvents] = useState<any>();
  const [isFirst, setIsFirst] = useState(true);
  const pageSize = 6;
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const years = Array.from({ length: 50 }, (_, i) => 2000 + i);
  const currentYear = new Date().getFullYear();
  const currentYearIndexDefault = years.indexOf(currentYear);
  const [year, setYear] = useState<number>(currentYearIndexDefault);
  const [month, setMonth] = useState(currentMonth);
  const topRef = useRef(null);
  const [checkedState, setCheckedState] = useState<CheckProps>({
    allEvents: true,
    dsuEvents: false,
    partnerEvents: false,
  });

  useEffect(() => {
    let filterType = "";
    console.log("month", month);
    let eventType = "all";
    if (selectedTab === 1) {
      filterType = "past";
      console.log("past1");
    } else {
      filterType = "upcoming";
      console.log("past2");
    }
    if (checkedState.dsuEvents) {
      eventType = "DSU";
      console.log("DSU");
    } else if (checkedState.partnerEvents) {
      eventType = "partner";
      console.log("parter");
    }
    newsAndMediaService
      .getEvents(
        currentPage,
        pageSize,
        inputText,
        filterType,
        month,
        year,
        eventType,
        isFirst
      )
      .then((data) => {
        setEvents(data);
        setTotalPages(data?.meta?.pagination?.pageCount);
        // setLoading(false);
        setIsFirst(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, [
    currentPage,
    pageSize,
    inputText,
    selectedTab,
    month,
    year,
    checkedState,
  ]);

  const EventCardsContent = (
    <Wrapper>
      {events?.data.length > 0 ? (
        <CardContainer>
          {events?.data?.map((card, index) => {
            return <EventCard key={index} {...card} />;
          })}
        </CardContainer>
      ) : (
        <CustomText
          text={t("app.noEvents")}
          type={TextType.P1}
          color={COLORS.MetalicSilver}
        />
      )}
    </Wrapper>
  );

  const PastEventCardsContent = (
    <Wrapper>
      {events?.data.length > 0 ? (
        <CardContainer>
          {events?.data?.map((card, index) => {
            return <EventCard key={index} {...card} />;
          })}
        </CardContainer>
      ) : (
        <CustomText
          text={t("app.noEvents")}
          type={TextType.P1}
          color={COLORS.MetalicSilver}
        />
      )}
    </Wrapper>
  );
  //eslint-disable-next-line
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    topRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const tabs = [
    {
      id: 0,
      tabTitle: t("view.newsAndMedia.events.currentEvents"),
      content: EventCardsContent,
      totalPages: totalPages,
      currentPage: currentPage,
      handlePageChange: handlePageChange,
      filtersType: Filters.present,
    },
    {
      id: 1,
      tabTitle: t("view.newsAndMedia.events.pastEvents"),
      content: PastEventCardsContent,
      totalPages: totalPages,
      currentPage: currentPage,
      handlePageChange: handlePageChange,
      filtersType: Filters.past,
    },
  ];

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleTabSelect = (selectedTabId: number) => {
    setSelectedTab(selectedTabId);
    setMonth(currentMonth);
    setYear(currentYearIndexDefault);
    setCheckedState({
      allEvents: true,
      dsuEvents: false,
      partnerEvents: false,
    });
  };

  return (
    <OfficialAnnouncementsContainer ref={topRef}>
      <TitleWrapper>
        <BackToWrapper
          onClick={() => navigate(appRoutes.news)}
          biggerCursor={biggerCursor}
        >
          <BackToImage src={LeftArrow} alt="backIcon" />
          <BackToButton biggerCursor={biggerCursor}>
            <CustomText
              text={t("view.newsAndMedia.officialAnnouncements.backButton")}
              type={TextType.H5bold}
              color={COLORS.RaisinBlack}
            />
          </BackToButton>
        </BackToWrapper>
        <CustomText
          text={t("view.newsAndMedia.events.filters.eventsCalendar")}
          type={TextType.H2}
        />
      </TitleWrapper>
      <HeaderWrapper>
        <HeaderTab
          tabs={tabs}
          onTabSelect={handleTabSelect}
          hasFilters={true}
          year={year}
          month={month}
          setYear={setYear}
          setMonth={setMonth}
          checkedState={checkedState}
          setCheckedState={setCheckedState}
        />
      </HeaderWrapper>
      <InputContainer>
        <form
          onSubmit={(event) => {
            event.preventDefault();

            if (inputText !== "") {
              setOptions([
                {
                  option: t("view.newsAndMedia.events.noResults"),
                  id: 0,
                  path: `/`,
                },
              ]);
            }
          }}
        >
          <InputAtom
            startAdornment={<ImgStyled src={RedLoop} alt="RedLoopIcon" />}
            endAdornment={
              <ButtonAtom
                text={t("view.newsAndMedia.officialAnnouncements.search")}
                type={ButtonType.ArrowDownDefault}
              />
            }
            placeholder={t(
              "view.newsAndMedia.officialAnnouncements.searchPlaceholder"
            )}
            isSearchBar={true}
            options={options}
            onChange={(e) => setInputText(e.target.value)}
            isModal={true}
          />
        </form>
      </InputContainer>
      {tabs[selectedTab].content}
      {tabs[selectedTab].totalPages > 1 && (
        <Pagination
          totalPages={tabs[selectedTab].totalPages}
          currentPage={tabs[selectedTab].currentPage}
          onPageChange={tabs[selectedTab].handlePageChange}
        />
      )}
    </OfficialAnnouncementsContainer>
  );
};

export default Events;
